export var OperatorType;
(function (OperatorType) {
    OperatorType["or"] = "or";
})(OperatorType || (OperatorType = {}));
export var Comparator;
(function (Comparator) {
    Comparator["is"] = "is";
    Comparator["isNot"] = "isNot";
})(Comparator || (Comparator = {}));
export var OutcomeType;
(function (OutcomeType) {
    OutcomeType["show"] = "show";
    OutcomeType["options"] = "options";
})(OutcomeType || (OutcomeType = {}));
export const isOperand = (condition) => {
    return 'field' in condition && 'matcher' in condition;
};
export const isShowOutcome = (condition) => {
    return condition.type === OutcomeType.show;
};
export const isOptionsOutcome = (condition) => {
    return condition.type === OutcomeType.options;
};
export var ElementType;
(function (ElementType) {
    ElementType["image"] = "image";
    ElementType["richtext"] = "richtext";
    ElementType["text"] = "text";
    ElementType["email"] = "email";
    ElementType["phone"] = "phone";
    ElementType["typeahead"] = "typeahead";
    ElementType["select"] = "select";
    ElementType["date"] = "date";
    ElementType["file"] = "file";
    ElementType["dataProtection"] = "dataProtection";
    ElementType["button"] = "button";
    ElementType["divider"] = "divider";
    ElementType["companyLogo"] = "companyLogo";
    ElementType["socialIcons"] = "socialIcons";
    ElementType["multiText"] = "multiText";
})(ElementType || (ElementType = {}));
export const isSelectElement = (element) => element.type === ElementType.select;
export const VISUAL_ELEMENTS = [
    ElementType.button,
    ElementType.companyLogo,
    ElementType.divider,
    ElementType.image,
    ElementType.richtext,
    ElementType.socialIcons,
];
